import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'ParkingList',
    component: () => import('../views/ParkingList.vue')
  },
  {
    path: '/vehicle',
    name: 'VehicleList',
    component: () => import('../views/VehicleList.vue')
  },
  {
    path: '/payment',
    name: 'PaymentList',
    component: () => import('../views/PaymentList.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
